export default __webpack_public_path__ + "static/media/BAYCRoadmap2.0.19fa6566.png";